<template>
  <header ref="topbar" class="modern-topbar">
    <router-link class="modern-topbar__brand" :to="{ name: 'ChartingNext' }" aria-label="Eurekers, ir al graficador">
      <img src="@/assets/logo.png" alt="" />
      <span>Eurekers</span>
    </router-link>

    <ModernPrimaryNavigation class="modern-topbar__desktop-navigation" />

    <button class="modern-topbar__mobile-toggle" type="button" aria-haspopup="menu" :aria-expanded="String(navigationOpen)"
      aria-label="Abrir navegación" @click="navigationOpen = !navigationOpen">☰</button>

    <ModernAccountTrigger ref="accountTrigger" :initials="identity.initials" :unread-count="notificationState.unreadCount"
      :open="accountOpen" @toggle="toggleAccount" />

    <nav v-if="navigationOpen" class="modern-topbar__mobile-navigation" aria-label="Navegación principal móvil">
      <template v-for="item in navigation">
        <router-link v-if="item.available" :key="item.id" :to="{ name: item.routeName }">{{ item.label }}</router-link>
        <button v-else :key="item.id" type="button" disabled>{{ item.label }} <small>Próximamente</small></button>
      </template>
    </nav>

    <ModernAccountMenu v-if="accountOpen" :identity="identity" :preference-state="preferenceState"
      :notification-state="notificationState" :fullscreen-state="fullscreenState" :chat-state="chatState"
      @close="closeAccount" @navigate="forwardAndClose('navigate', $event)" @mark-read="$emit('mark-read')"
      @theme="$emit('theme', $event)" @fullscreen="$emit('fullscreen')" @chat="$emit('chat')"
      @classic="forwardAndClose('classic')" @logout="forwardAndClose('logout')" />
  </header>
</template>

<script>
import ModernPrimaryNavigation from '@/shells/modern/ModernPrimaryNavigation.vue';
import ModernAccountTrigger from '@/shells/modern/ModernAccountTrigger.vue';
import ModernAccountMenu from '@/shells/modern/ModernAccountMenu.vue';
import { MODERN_NAVIGATION } from '@/shells/models/modernNavigation';

export default {
  name: 'ModernTopbar',
  components: { ModernPrimaryNavigation, ModernAccountTrigger, ModernAccountMenu },
  props: {
    identity: { type: Object, required: true },
    preferenceState: { type: Object, required: true },
    notificationState: { type: Object, required: true },
    fullscreenState: { type: Object, required: true },
    chatState: { type: Object, required: true }
  },
  data: () => ({ accountOpen: false, navigationOpen: false, navigation: MODERN_NAVIGATION }),
  watch: {
    '$route.fullPath'() { this.closeAccount(false); this.navigationOpen = false; }
  },
  mounted() { document.addEventListener('mousedown', this.onOutsideClick); },
  beforeDestroy() { document.removeEventListener('mousedown', this.onOutsideClick); },
  methods: {
    toggleAccount() {
      this.accountOpen = !this.accountOpen;
      this.navigationOpen = false;
      if (this.accountOpen) this.$emit('account-opened');
    },
    closeAccount(restoreFocus = true) {
      if (!this.accountOpen) return;
      this.accountOpen = false;
      if (restoreFocus) this.$nextTick(() => this.$refs.accountTrigger && this.$refs.accountTrigger.focus());
    },
    onOutsideClick(event) {
      if (this.accountOpen && this.$refs.topbar && !this.$refs.topbar.contains(event.target)) this.closeAccount(false);
    },
    forwardAndClose(eventName, payload) {
      this.closeAccount(false);
      this.$emit(eventName, payload);
    }
  }
};
</script>
